import { useQuery } from "@tanstack/react-query";
import groupService from "../api/groupService";

export const useGroup = (groupId) => {
  const { getGroup } = groupService();

  return useQuery({
    queryKey: ["get-group", groupId],
    queryFn: async () => {
      const res = await getGroup(groupId);
      return res.data;
    },
    enabled: !!groupId,
  });
};

export const useGroupUsers = (groupId) => {
  const { getGroupUsers } = groupService();

  return useQuery({
    queryKey: ["get-group-users", groupId],
    queryFn: async () => {
      const res = await getGroupUsers(groupId);
      return res.data;
    },
    enabled: !!groupId,
  });
};

export const useGroups = () => {
  const { getGroups } = groupService();

  return useQuery({
    queryKey: ["get-groups"],
    queryFn: async () => {
      const res = await getGroups();
      return res.data;
    },
  });
};
